// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"styles_buttonGroup__pL7V-","scaleQuestionBlock":"styles_scaleQuestionBlock__1mqmI","questionLead":"styles_questionLead__2oV71","bttn":"styles_bttn__2WmBs"};